"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _emblaCarouselReact = _interopRequireDefault(require("embla-carousel-react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faChevronRight = require("@fortawesome/pro-regular-svg-icons/faChevronRight");

var _faChevronLeft = require("@fortawesome/pro-regular-svg-icons/faChevronLeft");

var _core = require("@chakra-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var EmblaCarousel = function EmblaCarousel(_ref) {
  var accentColour = _ref.accentColour,
      arrowColour = _ref.arrowColour,
      progressIndicatorStyle = _ref.progressIndicatorStyle,
      children = _ref.children;

  var _useEmblaCarousel = (0, _emblaCarouselReact["default"])({
    breakpoints: {
      '(min-width: 768px)': {
        align: 'start'
      }
    },
    skipSnaps: false
  }),
      _useEmblaCarousel2 = _slicedToArray(_useEmblaCarousel, 2),
      emblaRef = _useEmblaCarousel2[0],
      emblaApi = _useEmblaCarousel2[1];

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      prevBtnDisabled = _useState2[0],
      setPrevBtnDisabled = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      nextBtnDisabled = _useState4[0],
      setNextBtnDisabled = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedIndex = _useState6[0],
      setSelectedIndex = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = _slicedToArray(_useState7, 2),
      scrollSnaps = _useState8[0],
      setScrollSnaps = _useState8[1];

  var scrollPrev = (0, _react.useCallback)(function () {
    return emblaApi && emblaApi.scrollPrev();
  }, [emblaApi]);
  var scrollNext = (0, _react.useCallback)(function () {
    return emblaApi && emblaApi.scrollNext();
  }, [emblaApi]);
  var scrollTo = (0, _react.useCallback)(function (index) {
    return emblaApi && emblaApi.scrollTo(index);
  }, [emblaApi]);
  var onInit = (0, _react.useCallback)(function (emblaApi) {
    setScrollSnaps(emblaApi.scrollSnapList());
  }, []);
  var onSelect = (0, _react.useCallback)(function (emblaApi) {
    setSelectedIndex(emblaApi.selectedScrollSnap());
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);
  (0, _react.useEffect)(function () {
    if (!emblaApi) return;
    onInit(emblaApi);
    onSelect(emblaApi);
    emblaApi.on('reInit', onInit);
    emblaApi.on('reInit', onSelect);
    emblaApi.on('select', onSelect);
  }, [emblaApi, onInit, onSelect]);
  return /*#__PURE__*/_react["default"].createElement(_core.Stack, {
    paddingX: '20px'
  }, /*#__PURE__*/_react["default"].createElement(_core.Stack, {
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    ref: emblaRef
  }, /*#__PURE__*/_react["default"].createElement(_core.Stack, {
    isInline: true,
    gridColumnGap: '30px'
  }, children), /*#__PURE__*/_react["default"].createElement(_core.Stack, {
    role: "button",
    onClick: scrollNext,
    style: {
      backgroundColor: accentColour
    },
    width: '50px',
    height: '50px',
    borderRadius: '9999px',
    cursor: 'pointer',
    position: 'absolute',
    top: '50%',
    right: '0',
    transform: 'translateY(calc(calc(50% + 60px) * -1))',
    alignItems: 'center',
    isInline: true,
    justifyContent: 'center',
    display: nextBtnDisabled ? 'none' : {
      base: 'none',
      md: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faChevronRight.faChevronRight,
    style: {
      color: arrowColour,
      fontSize: '24px'
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.Stack, {
    role: "button",
    onClick: scrollPrev,
    style: {
      backgroundColor: accentColour
    },
    width: '50px',
    height: '50px',
    borderRadius: '9999px',
    cursor: 'pointer',
    position: 'absolute',
    top: '50%',
    left: '0',
    transform: 'translateY(calc(calc(50% + 60px) * -1))',
    isInline: true,
    alignItems: 'center',
    justifyContent: 'center',
    display: prevBtnDisabled ? 'none' : {
      base: 'none',
      md: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faChevronLeft.faChevronLeft,
    style: {
      color: arrowColour,
      fontSize: '24px'
    }
  })), progressIndicatorStyle === 'dots' && /*#__PURE__*/_react["default"].createElement(_core.Stack, {
    isInline: true,
    alignItems: 'center',
    justifyContent: 'center',
    gridColumnGap: '0.5rem',
    marginTop: {
      base: '30px',
      md: '60px'
    }
  }, scrollSnaps.map(function (_, index) {
    return /*#__PURE__*/_react["default"].createElement(_core.Stack, {
      key: index,
      onClick: function onClick() {
        return scrollTo(index);
      },
      style: {
        backgroundColor: index === selectedIndex ? accentColour : '#D8D8D8'
      },
      width: '15px',
      height: '15px',
      borderRadius: '9999px',
      cursor: 'pointer'
    });
  }))));
};

var _default = EmblaCarousel;
exports["default"] = _default;